/**
 * Font-scale policy for large OS text sizes (iOS Dynamic Type, Android font
 * scale). Text is never prevented from scaling; it is capped by role so chrome
 * stays usable at the extreme sizes while reading content grows further.
 *
 * Spec: docs/superpowers/specs/2026-09-24-large-text-support-design.md
 */
export const FONT_SCALE_CAP = {
  /** Buttons, inputs, labels, rows, headers, tabs, chips, menus, amounts. */
  chrome: 1.5,
  /** Post bodies, messages, descriptions, legal text, empty-state copy. */
  content: 2.0,
  /** Count badges, avatar initials, calendar day numbers, 10–11pt tags. */
  micro: 1.2,
} as const;

export type TextScale = keyof typeof FONT_SCALE_CAP;

/** OS font scale at or above which label/value rows stack vertically. */
export const LARGE_TEXT_THRESHOLD = 1.3;
